module.exports = __webpack_public_path__ + "img/mobile/BetBar/btn-betland-up@3x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/BetBar/btn-betland-up@3x.png
// module id = 601
// module chunks = 0